import { Button } from "components/ui/button";
import { Form, FormField, FormItem, FormMessage } from "components/ui/form";
import { Input } from "components/ui/input";
import { toast } from "components/ui/use-toast";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { IAccountingAccount } from "src/@types/account-accouting";
import { z } from "zod";
import { useDialogModal } from "../../../../hook/handle-modal/hooks/actions";
import { useUpdateAccountingAccountMutation } from "../../../../services/account-accouting";
import { FormSchema } from "./validate-form";
import { MESSAGES } from "../utils/messages";
import { zodResolver } from "@hookform/resolvers/zod";

function Update({ row }: { row: IAccountingAccount }) {
  const [updateAccountingAccount, { isLoading }] =
    useUpdateAccountingAccountMutation();
  const { handleModal } = useDialogModal();

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      name: "",
    },
  });

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    try {
      await updateAccountingAccount({
        name: data?.name || "",
        version: row?.version || 0,
        id: row?.id || "",
        status: row?.status || "",
      }).unwrap();
      toast(MESSAGES.UPDATE.SUCCESS);
      handleModal({
        isOpen: false,
      });
      form.reset({
        name: row?.name || "",
      });
    } catch (e) {
      toast(MESSAGES.UPDATE.ERROR);
    }
  }

  useEffect(() => {
    form.reset({
      name: row?.name || "",
    });
  }, [row, form]);

  return (
    <div className="grid gap-4">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="space-y-4">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <Input
                    {...field}
                    hasError={!!form.formState.errors.name}
                    name="name"
                    placeholder="Conta Contábil."
                  />
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="flex w-full gap-4 justify-end">
              <button
                className="self-end w-max px-4 py-2 border border-black/20 flex items-center gap-2 rounded-md
                    text-black bg-white
                    transition-all duration-300 ease-in-out
                    hover:bg-[#2B0C1A] hover:text-white hover:border-transparent
                    "
                onClick={() => {
                  handleModal({
                    isOpen: false,
                  });
                }}
              >
                Voltar
              </button>
              <Button type="submit" variant="default" isLoading={isLoading}>
                Salvar
              </Button>
            </div>
          </div>
        </form>
      </Form>
    </div>
  );
}

export default Update;
